import type { TPlayer } from 'video.js'

import { Events } from '|>/shared/events'
import { span } from '|>/shared/h'
import { Intent } from '|>/shared/types/intent'
import { BaseAudioTrackMenuItem } from '../../base'
import { setStoredAudioTrack } from './audio-track-selection'

export class AudioTrackMenuItem extends BaseAudioTrackMenuItem {
  declare options_: any

  constructor(player: TPlayer, options: any) {
    super(player, options)
  }

  override createEl(type, props, attrs) {
    const el = super.createEl(type, props, attrs)

    const itemTextEl = el.firstElementChild

    if (this.options_.className?.includes('dolby-track') && itemTextEl) {
      el.appendChild(span('.vjs-icon-placeholder'))
    }

    const isDescriptionTrack =
      ['main-desc', 'descriptions'].indexOf(this.options_.track.kind) >= 0

    if (isDescriptionTrack && itemTextEl) {
      itemTextEl.appendChild(
        span('.vjs-icon-placeholder', { 'aria-hidden': true })
      )
      itemTextEl.appendChild(
        span('.vjs-control-text', {
          textContent: ' ' + this.localize('Descriptions'),
        })
      )
    }

    return el
  }

  // user manually clicked audio track option
  override handleClick(event) {
    this.player_.trigger(Events.User.Intent, Intent.ChangeAudio)

    super.handleClick(event)

    setStoredAudioTrack({
      id: this.track.id,
      label: this.track.label,
      language: this.track.language,
      kind: this.track.kind,
      isDolby: this.options_.isDolby,
    })
  }
}
